import { getJsonOrFalse } from "helpers/utils";
import type { TParamsPagination } from "store/types";

/**
 * Builds the same `getGeneralTabData` params as the Management "Général" tab persistence layer
 * (`localStorage` key `managementSortBy.terms` + `settings_pagination`). Used for programmatic
 * refetches (e.g. from Advance management) when `useAPIPagination` is not mounted.
 * When the user is on Management, prefer passing `handleRequest` from the parent instead
 * so the refetch uses live hook state and stays in sync with the table.
 */
export function getManagementTermsTabFetchParams(periodId: number): TParamsPagination {
    const stored = getJsonOrFalse(localStorage.getItem("managementSortBy") ?? "{}")?.terms as
        | TParamsPagination
        | undefined;
    const localLimit = parseInt(localStorage.getItem("settings_pagination") ?? "10", 10);
    return {
        periodId,
        limit: stored?.limit ?? localLimit,
        offset: stored?.offset ?? 0,
        query: stored?.query ?? "",
        sortBy: stored?.sortBy,
        sortOrder: stored?.sortOrder,
        titleTags: stored?.titleTags,
        beneficiaryTags: stored?.beneficiaryTags,
        brand: stored?.brand,
        paidStatus: stored?.paidStatus,
        grossDuty: stored?.grossDuty,
        control: stored?.control,
        extraParams: stored?.extraParams,
    };
}
